module.exports = __webpack_public_path__ + "static/media/asurion-protect-it-tablet.8da4607e.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-protect-it-tablet.jpg
// module id = 1389
// module chunks = 0